<template>
  <div class="carousel-main" @mousemove="carouselMouseMove" @mouseout="carouselMouseOut">
    <div class="carousel-container" v-for="i in viewCount" :key="i" :style="{ left: `${((i - 1) - currentViewIndex) * 100}%` }">
      <slot :name="`content${i}`"></slot>
    </div>
    <button class="next" :style="{ opacity: showButtons ? 0.4 : 0, cursor: currentViewIndex == viewCount - 1 ? 'not-allowed' : 'pointer' }"
      @click="changeView(true)" @mouseover="buttonMouseOver" @mouseout="buttonMouseOut">
      <img src="https://dsmlib.logistics.systems/Icons/Next.png" alt="" height="30" width="30">
    </button>
    <button class="prev" :style="{ opacity: showButtons ? 0.4 : 0, cursor: currentViewIndex == 0 ? 'not-allowed' : 'pointer' }"
      @click="changeView()" @mouseover="buttonMouseOver" @mouseout="buttonMouseOut">
      <img src="https://dsmlib.logistics.systems/Icons/Next.png" style="transform: rotate(180deg)" alt="" height="30" width="30">
    </button>
    <div class="view-indicator">
      <div class="view-dot" :class="{ 'view-selected': i - 1 == currentViewIndex }" v-for="i in viewCount" :key="i"
        @click="currentViewIndex = i - 1"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      currentViewIndex: 0,
      showButtons: false,
      showButtonsTimeout: null,
    }
  },
  props: {
    viewCount: { type: Number, default: 1 }
  },
  methods: {
    changeView: function(next) {
      if (next) {
        this.currentViewIndex++;
        if (this.currentViewIndex == this.viewCount) {
          this.currentViewIndex--;
        }
      } else {
        this.currentViewIndex--;
        if (this.currentViewIndex < 0) {
          this.currentViewIndex++;
        }
      }
    },
    carouselMouseMove: function() {
      this.setShowButtons(true);
      if (this.showButtonsTimeout) {
        clearTimeout(this.showButtonsTimeout);
      }
      this.showButtonsTimeout = setTimeout(() => this.setShowButtons(false), 2000);
    },
    carouselMouseOut: function() {
      if (this.showButtonsTimeout) {
        clearTimeout(this.showButtonsTimeout);
      }
      this.showButtons = false
    },

    buttonMouseOver: function() {
      this.showButtons = true;
      if (this.showButtonsTimeout) {
        clearTimeout(this.showButtonsTimeout);
      }
    },
    buttonMouseOut: function() {
      this.showButtons = false;
      if (this.showButtonsTimeout) {
        clearTimeout(this.showButtonsTimeout);
      }
    },

    setShowButtons: function(val) {
      this.showButtons = val;
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.carousel-main {
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 12px;
  overflow: hidden;

  > button {
    position: absolute;
    height: fit-content;
    top: 50%;
    border-radius: 0;
    border: none;
    background-color: transparent;
    width: 20%;
    opacity: 0;
    font-weight: bold;
    font-size: 5em;
    z-index: 3;
    display: flex;
    align-items: center;
    opacity: 0.4;

    &:focus {
      box-shadow: none;
    }

    &:hover {
      opacity: 1 !important;
      background-color: transparent;
    }

    > img {
      filter: drop-shadow(0 0 10px white);
    }
  }

  > .next {
    right: 0;
    justify-content: flex-end;
  }

  > .prev {
    left: 0;
    justify-content: flex-start;
  }

  > .carousel-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    transition: 0.3s;
    max-width: unset;
    padding: 5px;
    display: flex;
    flex-direction: column;
  }

  > .view-indicator {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > .view-dot {
      height: 15px;
      width: 15px;
      border-radius: 100%;
      border: 2px solid black;
      margin: 0 5px;
      transition: 0.3s;
      cursor: pointer;
    }

    > .view-selected {
      background-color: black;
    }
  }
}
</style>